<div mat-dialog-title class="flex-col justify-start">
  <div class="flex-row justify-between items-start">
    <h1 class="dialog-title">{{ title }}</h1>
    <button mat-button class="close-icon" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p>{{ description }}</p>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>{{ 'generic.filter' | translate }}</mat-label>
      <input matInput autofocus formControlName="filter">
    </mat-form-field>
  </form>
</div>
<mat-dialog-content>
  @if ((loading$ | async)) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- Parent item breadcrumb -->
  <div class="ou-parent">
    @if (shouldShowShowAllOption()) {
      <span>
        <button mat-button (click)="showRootView()">
          <mat-icon>reply</mat-icon>
          {{ "generic.show_all" | translate }}
        </button>
      </span>
    }
    @for (parentPath of parentPath; track parentPath) {
      <span>
        <!-- &raquo; -->
        @if (shouldShowPathEntry(parentPath)) {
          <button mat-button (click)="browseParent(parentPath)">
            <mat-icon>reply</mat-icon>
            {{parentPath.name}}
          </button>
        }
      </span>
    }
  </div>

  <!-- OU item list -->
  @for (node of (organizationUnitItems$ | async); track node) {
    <div class="ou-container" [ngClass]="{'selected': isCurrent(node)}">
      <div class="node ou-{{node.id}}" [ngClass]="{'selected': isSelected(node)}">
        <button mat-button (click)="toggleSelected(node)" [disabled]="!isSelectable(node)">
          <span class="ou-selection-button-content">
            @if (isSelectable(node)) {
              @if (isSelected(node) && data.allowMultipleSelection) {
                <mat-icon>check_box</mat-icon>
              }
              @if (!isSelected(node) && data.allowMultipleSelection) {
                <mat-icon>check_box_outline_blank</mat-icon>
              }
              @if (isSelected(node) && !data.allowMultipleSelection) {
                <mat-icon>check_circle</mat-icon>
              }
              @if (!isSelected(node) && !data.allowMultipleSelection) {
                <mat-icon>radio_button_unchecked</mat-icon>
              }
            }
            <mat-icon [svgIcon]="'ou-type-' + node.organization_unit_type_id"></mat-icon>
            <!-- Search item breadcrumb -->
            @if (node.path.length > 1 && !!currentSearchFilter) {
              @for (path of node.path.slice(1).reverse(); track path) {
                <span class="ou-name">{{path.name}} &raquo; </span>
              }
            }
            <span class="ou-name" [innerHTML]="node.name | highlight: currentSearchFilter"></span>
          </span>
        </button>
      </div>
      @if (!currentSearchFilter) {
        <div class="browse">
          @if (node.child_node_count) {
            <button mat-button (click)="browse(node)">
              <span class="browse-button-content">
                @if (node.organization_unit_type_id !== EOrganizationUnitType.LOCATION) {
                  <span class="ou-child-count">{{node.child_node_count}}</span>
                }
                <mat-icon>chevron_right</mat-icon>
              </span>
            </button>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>
<!-- Selected OU chips -->
<mat-dialog-actions>
  <mat-chip-listbox class="selected-ou-chip-listbox">
    @for (node of selectedOrganizationUnits; track node) {
      <mat-chip-option class="selected-ou-chip">
        <span class="selected-ou-chip-content">
          <mat-icon [svgIcon]="'ou-type-' + node.organization_unit_type_id"></mat-icon>
          <span>{{node.name}}</span>
        </span>
      </mat-chip-option>
    }
  </mat-chip-listbox>
  <div class="button-wrapper">
    <button mat-button [disabled]="selectedOrganizationUnits.length < this.minSelectedOrganizationUnits" (click)="confirm()">
      <span>{{ 'dialog.browse_organization_unit.select' | translate: {selectionCount: selectedOrganizationUnits.length} }}</span>
    </button>
  </div>
</mat-dialog-actions>

